/* KROSNO — paginacja listingów marek w stylu listingu natywnego.
   Plik: assets/krosno-listing-loadmore.js

   Sekcja collection-marka renderuje default_pagination ("1 2 Kolejny »").
   Listing natywny ma licznik "Wyświetlanie X z Y produktów" i ciemny przycisk
   "Zobacz więcej produktów". Ujednolicamy na drugi wariant, używając klas
   motywu (product-grid__load-more*), więc wygląd jest identyczny.

   Skrypt, a nie zmiana w Liquidzie: pliku sekcji nie da się nadpisać przez API
   (zapytanie ma limit 16 kB, sekcja waży 35 kB).

   NUMERACJA STRON: licznik własny (bieżąca strona + 1), adres budowany z adresu
   okna z podmienionym ?page=, więc filtry i sortowanie zostają. Pierwsza wersja
   brała "ostatni link z page=" z paginacji, a na stronie 2 jest nim "Poprzednia"
   (page=1) — skrypt skakał więc między stronami 1 i 2 w nieskończoność
   i dokładał wciąż te same produkty ("84 z 39").

   ZABEZPIECZENIA: kafelek dodawany tylko, gdy jego product-id nie ma jeszcze
   w siatce; koniec, gdy numer strony dobije do ostatniej (największy numer
   w paginacji) albo gdy strona nie przyniosła nic nowego.

   Doczepia same kafelki produktów — wstawki edytorialne są renderowane tylko na
   stronie 1. Bez JS zostaje zwykła paginacja, więc strona działa dalej. */

(() => {
  const numerStrony = (href) => {
    try {
      return parseInt(new URL(href, location.href).searchParams.get('page'), 10) || 0;
    } catch (e) {
      return 0;
    }
  };

  const ostatniaStrona = (root) => {
    const nav = root.querySelector('.mk__pagination');
    if (!nav) return 0;
    return Array.from(nav.querySelectorAll('a[href]'))
      .map((a) => numerStrony(a.getAttribute('href')))
      .reduce((a, b) => Math.max(a, b), 0);
  };

  const init = () => {
    const grid = document.querySelector('.mk__grid');
    const nav = document.querySelector('.mk__pagination');
    if (!grid || !nav || nav.dataset.krosnoLoadmore) return;
    nav.dataset.krosnoLoadmore = '1';

    let strona = parseInt(new URL(location.href).searchParams.get('page') || '1', 10) || 1;
    let ostatnia = Math.max(ostatniaStrona(document), strona);
    if (strona >= ostatnia) return;

    const widziane = new Set(
      Array.from(grid.querySelectorAll(':scope > li[data-product-id]')).map((li) => li.dataset.productId)
    );

    const razem = (() => {
      const pasek = document.querySelector('.facets-toggle') || document.body;
      const m = (pasek.textContent || '').match(/(\d[\d\s\u00a0]*)\s*PRODUKT/i);
      return m ? parseInt(m[1].replace(/[\s\u00a0]/g, ''), 10) : null;
    })();

    const adresStrony = (n) => {
      const u = new URL(location.href);
      u.searchParams.set('page', String(n));
      return u.toString();
    };

    const wrapper = document.createElement('div');
    wrapper.className = 'product-grid__load-more-wrapper';
    wrapper.innerHTML =
      '<p class="product-grid__load-more-count"></p>' +
      '<div class="product-grid__load-more">' +
      '<button type="button" class="button product-grid__load-more-button">Zobacz więcej produktów</button>' +
      '</div>';

    const licznik = wrapper.querySelector('.product-grid__load-more-count');
    const pudelko = wrapper.querySelector('.product-grid__load-more');
    const przycisk = wrapper.querySelector('.product-grid__load-more-button');

    const odswiez = () => {
      const n = grid.querySelectorAll(':scope > li:not(.mk__slot)').length;
      const koniec = strona >= ostatnia;
      let pokazane = n;
      if (razem) pokazane = koniec ? razem : Math.min(n, razem);
      licznik.textContent = 'Wyświetlanie ' + pokazane + (razem ? ' z ' + razem : '') + ' produktów';
    };

    odswiez();
    nav.replaceWith(wrapper);

    let trwa = false;

    przycisk.addEventListener('click', async () => {
      if (trwa || strona >= ostatnia) return;
      trwa = true;
      przycisk.disabled = true;
      przycisk.textContent = 'Wczytywanie…';

      try {
        const kolejna = strona + 1;
        const odp = await fetch(adresStrony(kolejna), { credentials: 'same-origin' });
        if (!odp.ok) throw new Error('HTTP ' + odp.status);
        const doc = new DOMParser().parseFromString(await odp.text(), 'text/html');

        let dodane = 0;
        doc.querySelectorAll('.mk__grid > li[data-product-id]').forEach((li) => {
          const id = li.dataset.productId;
          if (widziane.has(id)) return;
          widziane.add(id);
          grid.appendChild(document.importNode(li, true));
          dodane += 1;
        });

        strona = kolejna;
        ostatnia = Math.max(ostatnia, ostatniaStrona(doc), strona);
        if (dodane === 0) ostatnia = strona;

        odswiez();
        if (strona >= ostatnia) pudelko.hidden = true;
      } catch (e) {
        console.error('Doczytywanie produktów nie powiodło się', e);
      } finally {
        trwa = false;
        przycisk.disabled = false;
        przycisk.textContent = 'Zobacz więcej produktów';
      }
    });
  };

  /* Filtry i sortowanie podmieniają siatkę w locie — wtedy w DOM wraca świeża
     paginacja i skrypt podpina się do niej ponownie. */
  let czasomierz;
  const obserwuj = () => {
    new MutationObserver(() => {
      if (!document.querySelector('.mk__pagination:not([data-krosno-loadmore])')) return;
      clearTimeout(czasomierz);
      czasomierz = setTimeout(init, 60);
    }).observe(document.body, { childList: true, subtree: true });
  };

  const start = () => {
    init();
    obserwuj();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();